import { Expose, Type } from '@nts/std/serialization';
import { DomainModelMetaData } from './domain-model-meta-data';
import { AggregateMetaDataInterface, DomainModelMetaDataInterface } from '@nts/std/interfaces';

export class AggregateMetaData implements AggregateMetaDataInterface {

    constructor() {
        this.domainModels = [];
        this.useMessageResourceKey = true;
    }

    @Expose()
    @Type(() => DomainModelMetaData)
    domainModels: DomainModelMetaDataInterface[];

    @Expose()
    @Type(() => DomainModelMetaData)
    rootMetaData: DomainModelMetaDataInterface;


    // TODO transformare in get che punta a rootMetaData->name?
    @Expose()
    rootName: string;

    @Expose()
    rootFullName: string;

    @Expose()
    isDeactivable: boolean;

    @Expose()
    useMessageResourceKey: boolean;

}
